/* Dansk katalog for locale-autopilot-customers.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'ap.customerFollowup.title': 'Kundeopfølgning',
  'ap.customerFollowup.waiting': 'Venter på svar',
  'ap.customerFollowup.ready': 'Klar til tilbud',
  'ap.customerFollowup.document': 'Tilbud eller ordre til opfølgning',
  'ap.customerFollowup.openChat': 'Åbn chat',
  'ap.customerFollowup.empty': 'Ingen kunder har brug for opfølgning lige nu.',
});
